import axios from "axios";
import { getApiUrl } from "./Config";

const baseApiUrl = getApiUrl();

export function createObject(API_URL, object, functionName) {
  return axios.post(`${baseApiUrl}/${API_URL}/${functionName ? functionName : "create"}`, object);
}

export function createObjects(API_URL, objects, functionName = "CreateRange") {
  return axios.post(`${baseApiUrl}/${API_URL}/${functionName}`, objects);
}

export function getAllObjects(API_URL, methodName) {
  if (!methodName) methodName = "getAll";
  return axios.get(`${baseApiUrl}/${API_URL}/${methodName}`);
}

export function getObjectById(API_URL, objectId, methodName) {
  if (!methodName) methodName = "get";
  return axios.get(`${baseApiUrl}/${API_URL}/${methodName}/${objectId}`);
}

export function findObjects(API_URL, queryParams, queryMethodName) {
  return axios.post(`${baseApiUrl}/${API_URL}/${queryMethodName ? queryMethodName : "query"}`, queryParams);
}

export function getSpReports(API_URL, queryParams, funcName) {
  return axios.post(`${baseApiUrl}/${API_URL}/${funcName}`, queryParams);
}

export function getFile(API_URL, queryParams, funcName) {
  return axios.post(`${baseApiUrl}/${API_URL}/${funcName}`, queryParams, {
    responseType: "arraybuffer",
  });
}

export function pay(API_URL, object, funcName) {
  return axios.post(`${baseApiUrl}/${API_URL}/${funcName}`, object);
}

export function openBankUrl(API_URL, body) {
  return axios.post(`${API_URL}`, body);
}

export function updateObject(API_URL, object, functionName) {
  // return axios.put(`${baseApiUrl}/${API_URL}/update/${object.id}`, object);
  return axios.put(`${baseApiUrl}/${API_URL}/${functionName ? functionName : "update"}`, object);
}

export function copyObject(API_URL, objectId) {
  return axios.put(`${baseApiUrl}/${API_URL}/CopyObject/${objectId}`);
}

export function downloadImagebyFileId(API_URL, imageFileDescriptionId, methodName) {
  if (!methodName) methodName = "Downloadfile";
  return axios.get(`${baseApiUrl}/${API_URL}/${methodName}/${imageFileDescriptionId}`);
}

export function uploadImage(API_URL = "api/FileManagement", formFile, fileDesc, functionName) {
  // var fileList = []
  // fileList.push(formFile)
  // var filesDescription = []
  // filesDescription.push("test profile")
  const passData = new FormData();
  // passData.append('formFileList', fileList);
  // passData.append('filesDescription', filesDescription);

  passData.append('formFile', formFile);
  passData.append('fileDescription', JSON.stringify(fileDesc));
  // passData.append('fileDescription', formFile.);
  return axios.post(`${baseApiUrl}/${API_URL}/${functionName ? functionName : "UploadFile"}`, passData);
}

export function updateObjects(API_URL, ids, object, functionName) {
  // return axios.put(`${baseApiUrl}/${API_URL}/update/${object.id}`, object);
  return axios.put(`${baseApiUrl}/${API_URL}/${functionName ? functionName : "updateRange"}`, {
    idList: ids,
    updateValues: object,
  });

}

export function updateStatusForObjects(API_URL, ids, isDeleted) {
  if (isDeleted) {
    //status=isdeleted=true => deleteRange
    return axios.put(`${baseApiUrl}/${API_URL}/SoftDeleteRange`, {
      idList: ids,
    });
  } else {
    //status=isdeleted=false => RecoverDeleteRange
    return axios.put(`${baseApiUrl}/${API_URL}/RecoverDeleteRange`, {
      idList: ids,
    });
  }
}

export function deleteObject(API_URL, objectId) {
  // return axios.delete(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
  return axios.put(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
}

export function deleteObjects(API_URL, ids) {
  return axios.put(`${baseApiUrl}/${API_URL}/SoftDeleteRange`, { idList: ids });
}

export function hardDeleteObject(API_URL, objectId) {
  // return axios.delete(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
  return axios.delete(`${baseApiUrl}/${API_URL}/HardDelete/${objectId}`);
}

export function hardDeleteObjects(API_URL, ids) {
  // return axios.delete(`${baseApiUrl}/${API_URL}/SoftDelete/${objectId}`);
  // return axios.delete(`${baseApiUrl}/${API_URL}/HardDeleteRange`, {
  //   idList: ids,
  // });
  return axios.put(`${baseApiUrl}/${API_URL}/HardDeleteRange`, { idList: ids });
}
